import EmailLogin from './EmailLogin';

export default EmailLogin;
